import { render, staticRenderFns } from "./ConfirmationCard.vue?vue&type=template&id=58b0f82f&scoped=true"
import script from "./ConfirmationCard.vue?vue&type=script&lang=ts"
export * from "./ConfirmationCard.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationCard.vue?vue&type=style&index=0&id=58b0f82f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b0f82f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VRow})
